
<template>

</template>

<script>

import { mapActions } from 'vuex'

export default {
  name: 'Logout',
  methods: {
    ...mapActions([
      'logOut'
    ])
  },
  created () {
    this.logOut().then(response => { this.$router.push({ name: 'Login' }) })
  }
}
</script>



// WEBPACK FOOTER //
// Logout.vue?c465b91e